import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { Router } from "@angular/router";
import { SnackbarService } from "../../../../components/snackbar/snackbar.service";
import { TenantsApiService } from "../../../../shared/services/tenants.api.service";
import { TenantFormComponent } from "../../components/tenant-form/tenant-form.component";
import { CreateTenantRequest, TenantFormValue } from "../../models/tenant.model";

@Component({
    selector: "app-create-tenant",
    templateUrl: "./create-tenant.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TenantFormComponent]
})
export class CreateTenantComponent {
    private readonly tenantsService = inject(TenantsApiService);
    private readonly router = inject(Router);
    private readonly snackbarService = inject(SnackbarService);

    // In-flight guard so the primary can't double-submit.
    readonly submitting = signal(false);

    onSubmit(value: TenantFormValue): void {
        this.submitting.set(true);
        const request: CreateTenantRequest = { ...value };
        this.tenantsService.createTenant(request).subscribe({
            next: () => {
                this.snackbarService.show("Tenant created.", "success");
                void this.router.navigate(["/admin/tenants"]);
            },
            error: () => {
                this.submitting.set(false);
                this.snackbarService.show("We couldn’t save your changes. Try again.", "error");
            }
        });
    }
}
